import { formatRiskLabel, riskBandStyle, resolvedRiskLevel } from './riskScoreMeta'

export default function RiskScoreBadge({ score, level, size = 'default', className = '' }) {
  const resolvedLevel = resolvedRiskLevel(score, level)
  const style = riskBandStyle(score, resolvedLevel)
  const compact = size === 'compact'
  const padding = compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'
  const label = formatRiskLabel(score, resolvedLevel)

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full border ${padding} ${className}`}
      style={{ backgroundColor: style.bg, color: style.color, borderColor: style.border }}
      title="Patron risk score — current signal elevation (0–100)"
    >
      Risk {label}
    </span>
  )
}
